import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { baseUrlRisk, recommendationUrl } from '../../constants/constants';
import { getRiskAPIResponseData, getPostResponseAPIData } from '../../services/apiservices';
import { pushAccountTrendData } from '../../slices/EnvironmentwiseTrendSlice';
import { pushEnvironmentRiskData } from '../../slices/EnvironmentDrillChartSlice';
import DashBoard from '../Dashboard/Dashboard';
import { PageLayout } from '../MainPageStyle';
import { pushEnvironmentPageStatusCardData } from '../../slices/EnvironmentPageStatusCardSlice';
import Grid from '@material-ui/core/Grid';
import { PageTitle } from '../Dashboard/DashboardStyle';
import StatusCard from '../StatusCard/StatusCard';
import EnvironmentBreadCrumb from '../Breadcrumbs/EnvironmentBreadCrumb';
import { pushTableData } from '../../slices/recommendationTableSlice';
import { getApiResponseData } from '../../services/apiservices';
import { baseUrl } from '../../constants/constants';
import { pushClickEvent, pushEnvClickEvent, pushSelectedAccount } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushShowSpinner, pushHideSpinner } from '../../slices/SpinnerSlice';
import { pushExportRecommandationApi, pushExportRiskApi } from '../../slices/ApiStateSlice';
import { pushOverAllRiskScoreCardData } from '../../slices/OverAllRiskScoreCardSlice';
import { pushApplicationRiskData } from '../../slices/ApplicationDrillChartSlice';
import { pushSelectedApplication } from '../../slices/HeatMapSlice';
export default function TreeMapEnvironment(props) {
  let selectedAppIdParam = props.match.params.appId;
  let selectedAccountUuidParam = props.match.params.accountUuid;
  const dispatch = useDispatch();
  const [updatedpage, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [watch, setWatch] = React.useState(0);
  const [recomandationLoading, setRecomenationLoading] = React.useState(false);
  const [overallTrendLoading, setOverallTrendLoading] = React.useState(false);
  const [order, setOrder] = React.useState('DSC');
  const [orderBy, setOrderBy] = React.useState('entityRiskScore');

  const handlesetLoading = recomendationSpinnerStatus => {
    setRecomenationLoading(recomendationSpinnerStatus);
  };

  const handleOverallTrendLoading = overalTrendSpinnerLoading => {
    setOverallTrendLoading(overalTrendSpinnerLoading);
  };

  const handleRequestSort = property => {
    const isDsc = orderBy === property && order === 'DSC';
    setOrder(isDsc ? 'ASC' : 'DSC');
    setOrderBy(property);
  };

  const nextTableData = useSelector(state => state.recommendationTable.AccountResponse);
  const apiResponseData = useSelector(state => state.recommendationTable.AccountResponse);
  const updatedWatchData = useSelector(state => state.recommendationTable.WatchResponseData);
  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);
  const selectedAccount = useSelector(state => state.applicationDrillHeatMap.selectedAccount);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const recoReqBody = useSelector(state => state.riskFilterSlice.recoReqBody);
  let tableDataTest = [];
  useEffect(() => {
    dispatch(pushShowSpinner(true));
    let paginationStringOrigin = 'origins-wise';
    let riskUrl = baseUrlRisk + paginationStringOrigin;
    dispatch(getRiskAPIResponseData(riskUrl, 'riskResponse'));
    let paginationStringOriginWise = `accounts-wise?filter=appId=${selectedAppIdParam}&limit=${rowsPerPage}&offset=${updatedpage}`;
    let riskWiseUrl = baseUrlRisk + paginationStringOriginWise;
    dispatch(pushExportRiskApi(riskWiseUrl));
    dispatch(getRiskAPIResponseData(riskWiseUrl, 'applicationDrillHeatmap'));
    let paginationQueryString = '';

    if (watch) {
      paginationQueryString = `?filter=appId=${selectedAppIdParam},accountUuid=${selectedAccountUuidParam},underWatch=${watch},recoType=Any&limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&view=recommendation`;
      let exportUrl = baseUrl + paginationQueryString;
      dispatch(pushExportRecommandationApi(exportUrl));
    } else {
      paginationQueryString = `?filter=appId=${selectedAppIdParam},accountUuid=${selectedAccountUuidParam},recoType=Any&limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&view=recommendation`;
      let exportUrl = baseUrl + paginationQueryString;
      dispatch(pushExportRecommandationApi(exportUrl));
    }

    let url = baseUrl + paginationQueryString;

    if (!applyEvent) {
      dispatch(getApiResponseData(url, 'AccountResponse'));
    } else {
      dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
    }

    let paginationStringTrend = `account-trend?filter=appId=${selectedAppIdParam},accountUuid=${selectedAccountUuidParam}`;
    let trendUrl = baseUrlRisk + paginationStringTrend;
    dispatch(getRiskAPIResponseData(trendUrl, 'accountDrillTrend'));
    dispatch(pushEnvClickEvent(true));
    dispatch(pushClickEvent(true));
  }, [rowsPerPage, updatedpage, watch, updatedWatchData, order, orderBy, selectedAppIdParam, selectedAccountUuidParam]);
  const statuCardData = useSelector(state => state.environmentPageStatusCardSlice.statusData);
  const dataDoughnut = useSelector(state => state.environmentDrillChart.dataDoughnut);
  const dataLine = useSelector(state => state.environmentWiseTrend.dataLine);
  const environmentWiseTrendApiResponseData = useSelector(state => state.recommendationTable.accountDrillTrend);
  useEffect(() => {
    let originScoreParam = '';
    let originCategoryParam = '';
    let overallScoreParam = '';
    let overallRiskCatgParam = '';
    let selectedAppIdRiskData = [];

    if (riskApiResponseData && riskApiResponseData.data && riskApiResponseData.data.responseList) {
      let overAllRisk = riskApiResponseData.data.responseList;
      let overAllRiskObj = {};

      if (overAllRisk.length > 0) {
        overAllRiskObj['riskScore'] = overAllRisk[0].overallRiskScore;
        overAllRiskObj['riskCategory'] = overAllRisk[0].overallRiskCategory;
        overallScoreParam = overAllRiskObj.riskScore;
        overallRiskCatgParam = overAllRiskObj.riskCategory;
      }

      dispatch(pushOverAllRiskScoreCardData(overAllRiskObj));
      selectedAppIdRiskData = overAllRisk.filter(data => data.appId === selectedAppIdParam);
      originScoreParam = selectedAppIdRiskData[0].originRiskScore;
      originCategoryParam = selectedAppIdRiskData[0].originRiskCategory;
    }

    if (accountWiseApiResponseData && accountWiseApiResponseData.data && accountWiseApiResponseData.data.responseList) {
      let accountWiseData = accountWiseApiResponseData.data.responseList.filter(item => {
        return item.accountUuid === selectedAccountUuidParam;
      });
      let riskObject = {};

      if (accountWiseData.length > 0) {
        riskObject['riskScore'] = accountWiseData[0].originRiskScore;
        riskObject['riskCategory'] = accountWiseData[0].originRiskCategory;
        dispatch(pushEnvironmentRiskData(riskObject));
        dispatch(pushSelectedAccount(accountWiseData[0].envName));
        dispatch(pushSelectedApplication(accountWiseData[0].appName));
      }

      dispatch(pushApplicationRiskData(riskObject));
    }

    if (apiResponseData && apiResponseData.data) {
      let displayData = apiResponseData.data.responseList;
      dispatch(pushTableData(displayData));
      dispatch(pushHideSpinner(false));
    }

    if (environmentWiseTrendApiResponseData && environmentWiseTrendApiResponseData.data) {
      let environmentWiseTrendData = environmentWiseTrendApiResponseData.data;
      dispatch(pushAccountTrendData(environmentWiseTrendData));
      setOverallTrendLoading(true);
    }

    let riskDataObj = {
      originRiskScore: originScoreParam,
      originRiskCategory: originCategoryParam,
      overallRiskScore: overallScoreParam,
      overallRiskCategory: overallRiskCatgParam,
      origin: selectedApplication
    };
    dispatch(pushEnvironmentPageStatusCardData(riskDataObj));
  }, [apiResponseData, environmentWiseTrendApiResponseData, riskApiResponseData, accountWiseApiResponseData]);
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(EnvironmentBreadCrumb, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: '5px'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(PageTitle, null, selectedAccount)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(StatusCard, {
    statuCardData: statuCardData
  }))), /*#__PURE__*/React.createElement(DashBoard, {
    history: props.history,
    dataDoughnut: dataDoughnut,
    dataLine: dataLine,
    dashboardLabel: selectedAccount,
    tableData: tableDataTest,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: watch,
    setWatch: setWatch,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    order: order,
    orderBy: orderBy,
    applicationLabel: "Recommendation",
    riskLabel: "Risk Score",
    pageType: "entity"
  }));
}